// deps
import React, { memo, ReactElement, ReactNode, useContext, useMemo } from "react";
import classNames from "classnames";

//styles
import styles from "./styles.scss";

// internal-deps
import { isEmpty, withStyles } from "@swiggy-private/core-ui";

// test-ids
import { COMMON_HEADER_TEST_IDS } from "@swiggy-private/payment-test-ids";

//context
import { ShowPaymentContext } from "@payment-client/contexts/ShowPaymentContext";
import { PaymentPayContext } from "@payment-client/contexts/PaymentPayContext";

//helpers
import { getPaymentHeaderSubtitleV4 } from "@payment-client/helpers/PaymentHelper";
import { isBusinessLinePayOnDelivery, isBusinessLineSuper } from "@payment-client/helpers/Misc";

interface CommonHeaderContentProps {
    title: ReactNode;
    subtitle?: ReactNode;
    offerText?: string;
    grayscale?: boolean;
    quantity?: number;
    discountMessage?: string;
}

function CommonHeaderContent(props: CommonHeaderContentProps): ReactElement {
    const { title, subtitle, grayscale = false, quantity, discountMessage } = props;

    const { checkoutMetaInfo, paymentResponse } = useContext(ShowPaymentContext);
    const { billTotal } = useContext(PaymentPayContext);
    // use item quantity value from get payment methods response
    const itemCount = isBusinessLinePayOnDelivery() && !isEmpty(quantity) ? quantity : checkoutMetaInfo?.cartItemsCount;

    const ux4Subtitle = !isEmpty(subtitle)
        ? subtitle
        : getPaymentHeaderSubtitleV4({
              itemCount,
              amount: String(billTotal),
              paymentResponse,
          });

    // Only show discount message if business Line is NOT Super
    const showDiscountMessage = useMemo(() => !isBusinessLineSuper() && !isEmpty(discountMessage), [discountMessage]);

    const titleClass = classNames({
        [styles.headerTitleUx4]: true,
    });

    const subtitleClass = classNames({
        [styles.headerSubtitleUx4]: true,
        [styles.headerSubtitleGray]: grayscale,
    });

    return (
        <div className={styles.header}>
            <h1 className={titleClass} data-testid={COMMON_HEADER_TEST_IDS.TITLE}>
                {title}
            </h1>
            {(ux4Subtitle || showDiscountMessage) && (
                <div className={subtitleClass} data-testid={COMMON_HEADER_TEST_IDS.SUB_TITLE}>
                    {ux4Subtitle}
                    {showDiscountMessage ? <span className={styles.headerSubtitleOffer}>{discountMessage}</span> : ""}
                </div>
            )}
        </div>
    );
}

export default memo(withStyles(CommonHeaderContent, styles));
